import React, { useEffect, useState, useRef } from 'react';
import { Snackbar, Alert, AlertTitle, Box, useMediaQuery, useTheme } from '@mui/material';

// Snackbar único para toda la app: escucha tanto `api-error` (emitido por el
// interceptor de axios en services/api.js, para errores de transporte/backend
// que la pantalla no chequeó) como `app-toast` (emitido por services/toast.js,
// para que cada pantalla avise "se guardó"/"no se pudo guardar" de forma
// consistente en vez de armar su propio Alert/Snackbar local).
// Dedupea avisos repetidos en ventanas de 3s para no spamear si algo reintenta.

function GlobalErrorToast() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [aviso, setAviso] = useState(null);
  const lastSeenRef = useRef({});

  useEffect(() => {
    const mostrar = (detail) => {
      const key = `${detail.status || 'app'}|${detail.url || ''}|${detail.message || ''}`;
      const now = Date.now();
      const last = lastSeenRef.current[key] || 0;
      if (now - last < 3000) return;
      lastSeenRef.current[key] = now;
      setAviso(detail);
    };
    const handlerApiError = (e) => mostrar(e.detail || {});
    const handlerToast = (e) => mostrar(e.detail || {});
    window.addEventListener('api-error', handlerApiError);
    window.addEventListener('app-toast', handlerToast);
    return () => {
      window.removeEventListener('api-error', handlerApiError);
      window.removeEventListener('app-toast', handlerToast);
    };
  }, []);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setAviso(null);
  };

  if (!aviso) return null;

  return (
    <Snackbar
      open={!!aviso}
      autoHideDuration={aviso.severity === 'success' ? 4000 : 6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: isMobile ? 'center' : 'right' }}
      sx={{ bottom: isMobile ? '72px !important' : undefined }}
    >
      <Alert
        onClose={handleClose}
        severity={aviso.severity || 'error'}
        variant="filled"
        sx={{ maxWidth: 480 }}
      >
        {aviso.title && <AlertTitle sx={{ mb: 0.5 }}>{aviso.title}</AlertTitle>}
        <Box sx={{ fontSize: 13 }}>{aviso.message}</Box>
        {aviso.url && (
          <Box sx={{ fontSize: 11, opacity: 0.85, mt: 0.5, fontFamily: 'JetBrains Mono, Consolas, monospace', wordBreak: 'break-all' }}>
            {aviso.method} {aviso.url}
          </Box>
        )}
      </Alert>
    </Snackbar>
  );
}

export default GlobalErrorToast;
